import { render, staticRenderFns } from "./chineseWrap.vue?vue&type=template&id=f05d375a&scoped=true"
import script from "./chineseWrap.vue?vue&type=script&lang=js"
export * from "./chineseWrap.vue?vue&type=script&lang=js"
import style0 from "./chineseWrap.vue?vue&type=style&index=0&id=f05d375a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../Users/zhc/Documents/CF40/CF40-Java/cf40_pc_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05d375a",
  null
  
)

export default component.exports